import React, { useEffect, useState } from 'react'
import Tools from '../../../cvp-webgames-core/Misc/Tools';
import { PreCacheItem, SinglePreCacheItem, PrecacheItemType } from '../../../cvp-webgames-core/pre-caching/pre-cache-item';
import { constants } from '../../../misc/constants';
import { TextHtmlTagType, generalAudioCaching, getGlobalTextSizeStyle, getSaveData, setAnimationState, setFocus, setVisibilityState, updateLast508Window } from '../../../misc/tools';
import { BaseConfig } from '../../BaseConfig';
import PopUp4 from '../../general/pop-up4';
import { UIProperties } from '../../../cvp-webgames-core/Components/ui/UIProperties';

import "./top-left-controls-ui.css"

class TopLeftControlsUICaching extends PreCacheItem {
	public getItems(): SinglePreCacheItem[] {
		return [
			{
				type: PrecacheItemType.Image,
				key: 'visibility',
				src: process.env.PUBLIC_URL + '/assets/images/main-menu/visibility.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'volumeOn',
				src: process.env.PUBLIC_URL + '/assets/images/vid-controller/audio-on.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'volumeOff',
				src: process.env.PUBLIC_URL + '/assets/images/vid-controller/audio-muted.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'motionOn',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/motion.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'motionOff',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/motion-disabled.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'animations',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/animations.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'ccOn',
				src: process.env.PUBLIC_URL + '/assets/images/closed-captioning-on.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'ccOff',
				src: process.env.PUBLIC_URL + '/assets/images/closed-captioning-off.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'accessibility',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/accessibility-enabled.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'return-to-main-menu',
				src: process.env.PUBLIC_URL + '/assets/images/scenarios/hud/return-to-main-menu.svg'
			},
			{
				type: PrecacheItemType.Image,
				key: 'return1',
				src: process.env.PUBLIC_URL + '/assets/images/return1.svg'
			}
		];
	}
}

export const topLeftControlsUICaching = new TopLeftControlsUICaching();

var isCCEnabled = false;
var isAudioEnabled = false;
var isContentPlaying = false;
var isAccessibilityEnabled = false;
let addOnColorSchemeChangedHandler : any = null;
let lastFocusedItem = 'simple-accessibility-content-top';

const TopLeftControlsUI = (props: UIProperties<TopLeftControlsUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(true);
	const [isDarkTheme, setIsDarkTheme] = useState(Tools.isUsingDarkMode());

	// if(isAccessibilityEnabled) {
	// 	setTimeout(() => {
	// 		// if(document.getElementById(lastFocusedItem).querySelector('#' + document.activeElement.id)) {
	// 		// 	return;
	// 		// }

	// 		setFocus(lastFocusedItem);
	// 	}, 1500);
	// }
	
	const savedData = getSaveData();

	(window as any)['core-volume-state'] = (isEnabled: boolean) => {
		isAudioEnabled = isEnabled;
		setForceUpdate(!forceUpdate);
	}

	(window as any)['core-cc-state'] = (isEnabled: boolean) => {
		isCCEnabled = isEnabled;
		setForceUpdate(!forceUpdate);
	}

	(window as any)['core-motion-state'] = (isEnabled: boolean) => {
		isContentPlaying = isEnabled;
		setForceUpdate(!forceUpdate);
	}

	isCCEnabled = savedData.isClosedCaptionEnabled;
	isAudioEnabled = savedData.isAudioEnabled;
	isContentPlaying = savedData.isMotionEnabled;

	useEffect(() => {
		addOnColorSchemeChangedHandler = Tools.addOnColorSchemeChanged((isDarkMode: boolean) => {
			setIsDarkTheme(isDarkMode);
		});

		return () => {
			Tools.removeOnColorSchemeChanged(addOnColorSchemeChangedHandler)
		}
	}, [])

	const onAccessMenuClosed = () => {
		if(isAccessibilityEnabled) {
			localStorage.setItem('accessibility_menu_open-jcdst', '1');
		} else {
			
			updateLast508Window();
			localStorage.removeItem('accessibility_menu_open-jcdst');
		}
		if(isAccessibilityEnabled) {
			(window as any)['set-508-window-simple-accessibility-on']();
		} else {
			(window as any)['set-508-window-simple-accessibility-off']();
		}
	}

	const onAccessibilityClicked = () => {
		isAccessibilityEnabled = !isAccessibilityEnabled;
		
		// if(props.parameters.onForceRefreshEntireUI) {
		// 	props.parameters.onForceRefreshEntireUI();
		// }

		onAccessMenuClosed();
		
		setForceUpdate(!forceUpdate);
	}
	const getIconTheme = () => {
		return {
			filter: isDarkTheme ? 'invert(1)' : 'unset'
		}
	}

	const saveData = getSaveData();

	return (
		<div className='top-left-ui-root '>
			<div className="modal-disable-select main-content hud-ui-container" style={{
			}}>
				<div className='hud-ui-inner-container'>
					<div className={props.parameters.mmAria} tabIndex={(props.parameters.mmAria==='main-menu-button' ? -1 : 0)} onKeyUp={Tools.mapDivEnterToClick} onMouseEnter={() => {
							const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.click_04_01).src;
							Tools.playOneShotSound(url);
						}} onClick={() => {
							const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.digi_plink_01).src;
							Tools.playOneShotSound(url);
							if(props.parameters.onReturnToMenuClicked) {
								props.parameters.onReturnToMenuClicked();
							}
						}} role="button" aria-label='Return to Main Menu' >
						<img className={'center-element-horizontal ' + (props.parameters.mmColor==='make-grey' ? props.parameters.mmColor : 'make-white')} src={topLeftControlsUICaching.getItemByKey('return-to-main-menu').src} />
					</div>
					

					<div onMouseEnter={() => {
							const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.click_04_01).src;
							Tools.playOneShotSound(url);
						}} tabIndex={0} onKeyUp={Tools.mapDivEnterToClick} onClick={() => {
							isContentPlaying = !isContentPlaying;
							if((window as any)['core-motion-state-reverse']) {
								(window as any)['core-motion-state-reverse'](isContentPlaying);
							}
							const url = generalAudioCaching.getItemByKey(isContentPlaying ? generalAudioCaching.audioKeys.beep_short_on_01 : generalAudioCaching.audioKeys.beep_short_off_01).src;
							Tools.playOneShotSound(url);
							props.parameters.onTogglePause(isContentPlaying);
							
							setForceUpdate(!forceUpdate);
						}} role="button" aria-label={saveData.isMotionEnabled ? 'Toggle Motion (On)' : 'Toggle Motion (Off)'}>
						<img className='center-element-horizontal make-white' src={(saveData.isMotionEnabled ? topLeftControlsUICaching.getItemByKey('motionOn') : topLeftControlsUICaching.getItemByKey('motionOff')).src} />
					</div>
					
					<div tabIndex={0} onKeyUp={Tools.mapDivEnterToClick} onMouseEnter={() => {
							const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.click_04_01).src;
							Tools.playOneShotSound(url);
						}} onClick={() => {
							isAudioEnabled = !isAudioEnabled;
							const url = generalAudioCaching.getItemByKey(isAudioEnabled ? generalAudioCaching.audioKeys.beep_short_on_01 : generalAudioCaching.audioKeys.beep_short_off_01).src;
							if(!isAudioEnabled) {
								Tools.playOneShotSound(url);
							}
							props.parameters.onAudioToggled(isAudioEnabled);
							if(props.parameters.onForceRefreshEntireUI) {
								props.parameters.onForceRefreshEntireUI();
							}
							setForceUpdate(!forceUpdate);

							if(isAudioEnabled) {
								Tools.playOneShotSound(url);
							}
						}} role="button" aria-label={(saveData.isAudioEnabled ? 'Toggle Audio (On)' : 'Toggle Audio (Off)')} >
						<img className='center-element-horizontal make-white' src={(saveData.isAudioEnabled ? topLeftControlsUICaching.getItemByKey('volumeOn') : topLeftControlsUICaching.getItemByKey('volumeOff')).src} />
					</div>
					
					<div tabIndex={0} onMouseEnter={() => {
							const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.click_04_01).src;
							Tools.playOneShotSound(url);
						}} onKeyUp={Tools.mapDivEnterToClick} onClick={() => {
							isCCEnabled = !isCCEnabled;
							const url = generalAudioCaching.getItemByKey(isCCEnabled ? generalAudioCaching.audioKeys.beep_short_on_01 : generalAudioCaching.audioKeys.beep_short_off_01).src;
							Tools.playOneShotSound(url);
							props.parameters.onToggleCC(isCCEnabled);
							if(props.parameters.onForceRefreshEntireUI) {
								props.parameters.onForceRefreshEntireUI();
							}
							setForceUpdate(!forceUpdate);
						}}  role="button" aria-label={(saveData.isClosedCaptionEnabled ? 'Toggle Closed Captions (On)' : 'Toggle Closed Captions (Off)')} >
						<img className='center-element-horizontal make-white' src={(saveData.isClosedCaptionEnabled ? topLeftControlsUICaching.getItemByKey('ccOn') : topLeftControlsUICaching.getItemByKey('ccOff')).src} />
					</div>
					
					<div tabIndex={0} onMouseEnter={() => {
							const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.click_04_01).src;
							Tools.playOneShotSound(url);
						}} onKeyUp={Tools.mapDivEnterToClick} role="button" onClick={() => {
							const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.digi_plink_01).src;
							Tools.playOneShotSound(url);
							onAccessibilityClicked();
						}} aria-label={'Accessibility'}>
						<img className='center-element-horizontal make-white' src={topLeftControlsUICaching.getItemByKey('accessibility').src} />
					</div>
				</div>
			</div>
			{isAccessibilityEnabled ? <div className='top-left-ui-accessibility-menu black-overlay'  onMouseEnter={() => {
					const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.click_04_01).src;
					Tools.playOneShotSound(url);
				}}  onClick={onAccessibilityClicked}>
						<div className='top-left-ui-accessibility-menu-inner' onClick={(e: any) => e.stopPropagation()}>
							<PopUp4
								hideEverythingButButtons={true}
								title= {null}
								previousMenuBttn={
									{
										idFor508: 'simple-accessibility-content-bottom',
										alt508: '',
										imgSrc: topLeftControlsUICaching.getItemByKey('return1').src,
										width: '80%',
										height: '80px',
										buttonText: "Close",
										onClick: () => {
											isAccessibilityEnabled = false;
											onAccessMenuClosed();
											setForceUpdate(!forceUpdate)
										},
										hoverColor: constants.design.hoverColor2
									}}
								toggleButtons={[
									{
										idFor508: 'simple-accessibility-content-top',
										alt508: '',
										imgSrc: topLeftControlsUICaching.getItemByKey('visibility').src,
										imgStyle: getIconTheme(),
										width: '80%',
										height: '80px',
										buttonText: "Visible focus",
										isSelected: false,
										defaultIsEnabled: savedData.isVisibleFocusEnabled,
										onToggled: (val: boolean) => {
											setVisibilityState(val);
											if(props.parameters.onForceRefreshEntireUI) {
												props.parameters.onForceRefreshEntireUI();
											}
										}
									},
									{
										imgSrc: topLeftControlsUICaching.getItemByKey('animations').src,
										alt508: '',
										imgStyle: getIconTheme(),
										animImage: true,
										width: '80%',
										height: '80px',
										buttonText: "Animations",
										isSelected: false,
										defaultIsEnabled: savedData.isAnimationsEnabled,
										onToggled: (val: boolean) => {
											setAnimationState(val);
											if((window as any)['core-animation-state-reverse']) {
												(window as any)['core-animation-state-reverse'](val);
											}
											// if(props.parameters.onForceRefreshEntireUI) {
											// 	props.parameters.onForceRefreshEntireUI();
											// }
										}
									}
								]}
								onRenderContent={() => {
									return (
										<p className='default-text center-element-horizontal white-text' style={{
											textAlign:'center',
											width: '100%',
											...getGlobalTextSizeStyle(TextHtmlTagType.p)
										}}>
											<span className='title-text2'>Accessibility</span><br />
											<br />
											Adjust your experience below:
										</p>);
								}}></PopUp4> 
						</div>
					</div> : (null)}
		</div>
	);

};

export interface TopLeftControlsUIConfig extends BaseConfig {
	onForceRefreshEntireUI: () => void;
	onReturnToMenuClicked: () => void;
	onAudioToggled: (isEnabled: boolean) => void;
	onToggleCC: (isEnabled: boolean) => void;
	onTogglePause: (isEnabled: boolean) => void;
	mmAria?: string;
	mmColor?:string;
}

export default TopLeftControlsUI;